import React from 'react';
import H2Homepage from "./H2homepage";
import Riboahp from "./Riboahp";
import iconinvitedsoon from '../../style/icons/invitedsoon.svg'


const InvitedSoonContainer = () => {
    return (
        <div className={'notif-container'}>
            <H2Homepage title={'המוזמנים קרובים'} iconName={iconinvitedsoon}/>
                <div className={'riboa-main'}>
                    <Riboahp/>
                    <Riboahp/>
                    <Riboahp/>
                    <Riboahp/>
                </div>
        </div>
)
}
export default InvitedSoonContainer;